import React from 'react';
import MainMenu3 from './MainMenu3';

function Header3() {
    return (
        <>
            <MainMenu3 />
        </>
    );
}

export default Header3;
